export default __webpack_public_path__ + "static/media/compas_project_search_prospect.e41e3660.gif";